<template>
  <div class="row">
    <div class="col-sm-9">
      <div class="row">
        <div class="col-md-12">
          <div v-if="productInformationAvailable">
            <h1>{{ medicineName }} Reviews</h1>

            Genuine customer reviews for
            <a :href="websiteUrl">{{ medicineName }}</a>

            <div v-if="feefoReviewsAvailable">
              <div class="feefo-rating-widget">
                <!-- Tab panes -->
                <div class="review-summary">
                  <div itemprop="aggregateRating" itemtype="http://schema.org/AggregateRating">
                    <div class="row">
                      <div class="col-xs-7 col-sm-5">
                        <div class="feefo-rating-big">
                          <span itemprop="ratingValue" v-text="averageReviewFormatted" />
                          <span class="small">/ <span itemprop="bestRating">5</span></span>
                        </div>

                        <div class="stars">
                          <span
                            v-for="star in fullStarCount"
                            :key="`full-star_${star}`"
                            class="common-sprite sprite-star"
                          />
                          <span
                            v-for="star in halfStarCount"
                            :key="`half-star_${star}`"
                            class="common-sprite sprite-star-half"
                          />
                          <span
                            v-for="star in emptyStarCount"
                            :key="`empty-star_${star}`"
                            class="common-sprite sprite-star-empty"
                          />
                        </div>
                      </div>

                      <div class="col-xs-5 col-sm-7">
                        <table class="feefo-bars-table">
                          <tr v-for="numberOfStars in 5" :key="'feefo-bar-row_' + numberOfStars">
                            <td class="fbt-1">{{ (numberOfStars - 6) * -1 }}</td>
                            <td class="fbt-2"><i class="star-small" /></td>
                            <td class="fbt-3">
                              <div class="feefo-bar-container">
                                <div
                                  class="feefo-bar"
                                  :style="`width:${(ratingList[(numberOfStars - 5) * -1] / reviewsCount) * 100}%`"
                                ></div>
                              </div>
                            </td>
                            <td class="fbt-4">
                              {{ ratingList[(numberOfStars - 5) * -1] }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <p class="notice">
                          Based on <span itemprop="reviewCount">#{reviewsCount}</span> independent customer reviews
                          taken by Feefo (see all
                          <a
                            target="_blank"
                            rel="noreferrer noopener"
                            :href="`http://www.feefo.com/GB/en/reviews/${companyName}-Online-Pharmacy_uk/?id=1008513`"
                            >{{ companyName }} Reviews</a
                          >).
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ReviewsList :reviews="reviews" :url="reviewsUrl" :count="reviewsCount" />
            </div>
          </div>

          <h1 v-else>This product does not exist.</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ReviewsList from "./ReviewsList.vue";

const {
  productInformationAvailable,
  medicineName,
  websiteUrl,
  feefoReviewsAvailable,
  averageReview,
  ratingMap,
  companyName,
  reviews,
  reviewsUrl,
  reviewsCount,
} = window.ProductReviewsProps;

export default Vue.extend({
  components: {
    ReviewsList,
  },
  data() {
    return {
      productInformationAvailable,
      medicineName,
      websiteUrl,
      feefoReviewsAvailable,
      averageReview: !isNaN(parseFloat(averageReview)) ? parseFloat(averageReview) : 0.0,
      ratingList: ratingMap
        .replaceAll("}", "")
        .replaceAll("{", "")
        .split(",")
        .map((item) => item.trim())
        .map((item) => item.substring(2)),
      companyName,
      reviews,
      reviewsUrl,
      reviewsCount,
    };
  },
  computed: {
    averageReviewFormatted() {
      return this.averageReview.toFixed(1);
    },
    ratingRoundedToUpperHalf() {
      let ret = this.averageReview;
      ret = ret * 2;
      ret = Math.ceil(ret);
      ret = ret / 2;
      return ret;
    },
    fullStarCount() {
      return Math.floor(this.ratingRoundedToUpperHalf);
    },
    halfStarCount() {
      return (this.ratingRoundedToUpperHalf - this.fullStarCount) * 2;
    },
    emptyStarCount() {
      return 5 - this.fullStarCount - this.halfStarCount;
    },
  },
});
</script>
